<template>
    <div>
        <b-modal
            id="screening-detail-popup"
            ref="my-modal"
            size="md"
            cancel-variant="link"
            :hide-header-close="loading"
            no-close-on-backdrop
            no-close-on-esc
            content-class="name-screening-detail"
        >
            <template v-slot:modal-header="{ close }" class="header-logo">
                <!-- Emulate built in modal header close button action -->
                <h5 class="modal-title float-left">
                    Modify Name Screening Hit
                </h5>
                <img src="@/assets/images/logo-auth.svg" class="show-print" />
                <button
                    type="button"
                    aria-label="Close"
                    class="close"
                    @click="close()"
                >
                    ×
                </button>
            </template>

            <div class="screening-hit-section">
                <div class="row">
                    <div class="col-md-4">
                        <label>Full Name:</label>
                    </div>
                    <div class="col-md-8">
                        {{ selectedItem && selectedItem.name | firstName }}
                    </div>
                    <div class="col-md-4">
                        <label>Father's Name:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.fathersName
                                ? selectedItem.fathersName
                                : 'N/A'
                        }}
                    </div>
                    <div class="col-md-4">
                        <label>Date of Birth:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.sourceDob
                                ? updatedOnDate(selectedItem.sourceDob)
                                : 'N/A'
                        }}
                    </div>
                    <div class="col-md-4">
                        <label>Nationality:</label>
                    </div>
                    <div class="col-md-8">
                        {{ selectedItem && selectedItem.country | citizenship }}
                    </div>
                    <div class="col-md-4">
                        <label>List:</label>
                    </div>
                    <div class="col-md-8">
                        {{ selectedItem && selectedItem.gender | gender }}
                    </div>
                    <div class="col-md-4">
                        <label>Country Of Residence:</label>
                    </div>
                    <div class="col-md-8">
                        {{ selectedItem && selectedItem.country | residenceOf }}
                    </div>
                    <div
                        v-if="
                            selectedItem &&
                            selectedItem.identificationType &&
                            selectedItem.identificationType.length &&
                            selectedItem.identificationType[0].type !== '' &&
                            selectedItem.identificationType[0].value !== ''
                        "
                        class="col-md-12"
                    >
                        <div
                            v-for="(list, index) in selectedItem &&
                            selectedItem.identificationType"
                            :key="index"
                        >
                            <label class="w-200">
                                {{ list.type | capitalize }}
                            </label>
                            <span class="w-300">
                                {{ list.value }}
                            </span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <label>Source List:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.sourceList
                                ? selectedItem.sourceList
                                : 'N/A'
                        }}
                    </div>
                    <div class="col-md-4">
                        <label>List Type:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.listType
                                ? selectedItem.listType
                                : 'N/A'
                        }}
                    </div>
                    <div class="col-md-4">
                        <label>Source Reference ID:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.sourceReferenceId
                                ? selectedItem.sourceReferenceId
                                : 'N/A'
                        }}
                    </div>
                    <div class="col-md-4">
                        <label>Title:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.title
                                ? selectedItem.title
                                : 'N/A'
                        }}
                    </div>
                    <div class="col-md-4">
                        <label>Biography:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.biography
                                ? selectedItem.biography
                                : 'N/A'
                        }}
                    </div>
                    <div v-if="description.length" class="col-md-4">
                        <label>Description:</label>
                    </div>
                    <div v-if="description.length" class="col-md-8">
                        <ul>
                            <li
                                v-for="(list, index) in description"
                                :key="index"
                            >
                                <span v-if="list.type == 'Snippet'">{{
                                    list.value | capitalize
                                }}</span>
                                <a
                                    v-if="list.type == 'Link'"
                                    :href="list.value"
                                    target="_blank"
                                >
                                    Reference
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-4">
                        <label>Address:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.address
                                ? selectedItem.address
                                : 'N/A'
                        }}
                    </div>
                    <div class="col-md-4">
                        <label>Place Of Birth:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.placeOfBirth
                                ? selectedItem.placeOfBirth
                                : 'N/A'
                        }}
                    </div>
                    <div class="col-md-4">
                        <label>List Category:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.listCategory
                                ? selectedItem.listCategory
                                : 'N/A'
                        }}
                    </div>
                    <div class="col-md-4">
                        <label>Category:</label>
                    </div>
                    <div class="col-md-8">
                        {{
                            selectedItem && selectedItem.category
                                ? selectedItem.category
                                : 'N/A'
                        }}
                    </div>
                    <div class="col-md-4">
                        <label>Status:</label>
                    </div>
                    <div class="col-md-8">
                        <div v-if="selectedItem && selectedItem.listStatus">
                            Active since
                            {{ updatedOnDate(selectedItem.addedOn) }}
                        </div>
                        <div v-if="selectedItem && !selectedItem.listStatus">
                            Inactive since
                            {{ updatedOnDate(selectedItem.updatedOn) }}
                        </div>
                    </div>
                </div>
            </div>

            <template slot="modal-footer" class="w-100">
                <!-- Emulate built in modal footer ok and cancel button actions -->

                <a
                    href="javascript:;"
                    class="ml-3 d-none-print"
                    @click="hideModal()"
                    >Cancel</a
                >

                <b-button
                    variant="primary"
                    class="d-none-print"
                    @click="print()"
                >
                    Print
                </b-button>

                <!-- <base-button
                    btnLabel="Print"
                    btnType="button"
                    btnVariant="primary"
                ></base-button> -->

                <div class="client-footer-logo">
                    <h4>Source:</h4>

                    <img :src="image" />
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > filters
    |--------------------------------------------------------------------------
    */
    filters: {
        primaryName: function (value) {
            if (!value) return 'N/A'
            value = value.filter((v) => {
                return v.type === 'Primary Name'
            })

            return value[0].firstName + ' ' + value[0].lastName
        },
        aliasName: function (value) {
            if (!value) return 'N/A'
            value = value
                .filter((v) => v.type !== 'Primary Name')
                .map((v) => v.firstName + ' ' + v.lastName)
            return value.length ? value.join() : 'N/A'
        },
        gender: function (gender) {
            return gender ? _.startCase(gender) : 'N/A'
        },
        firstName: function (value) {
            if (!value) return 'N/A'
            value = value.filter((v) => {
                return v.type === 'Primary Name'
            })

            return value[0].firstName
        },
        lastName: function (value) {
            if (!value) return 'N/A'
            value = value.filter((v) => {
                return v.type === 'Primary Name'
            })

            return value[0].lastName
        },

        dateOfBirth: function (dates) {
            if (dates && dates.length) {
                return this.$moment(selectedItem.addedOn).format('MMM DD, YYYY')
            }
            return 'N/A'
        },
        citizenship: function (value) {
            if (value) {
                let citizenship = value.filter((v) => {
                    return v.type === 'Citizenship'
                })
                if (citizenship && citizenship[0] && citizenship[0].name) {
                    return citizenship[0].name
                }
            }
            return 'N/A'
        },
        residenceOf: function (value) {
            if (value) {
                let residenceOf = value.filter((v) => {
                    return v.type === 'Resident of'
                })
                if (residenceOf && residenceOf[0] && residenceOf[0].name) {
                    return residenceOf[0].name
                }
            }
            return 'N/A'
        },
    }, // End of Component > filters
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            dowJonesLogo: 'dow-logo.png',
            worldCheckLogo: 'refinitiv-logo-schema.png',
            //ListStatus: active,
        }
    },
    mounted() {
        //console.log('selected item ', this.selectedItem)
        //this.ListStatus = this.selectedItem.status;
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'selectedItem',
            'hidePopup',
            'displaySettings',
        ]),
        categoreis() {
            //console.log('this.selectedItem', this.selectedItem)
            let data = []
            if (this.selectedItem && this.selectedItem.category) {
                data = [...data, this.selectedItem.category]
            }

            return data
        }, // End of categoreis() method
        description() {
            let data = []
            if (
                this.selectedItem &&
                this.selectedItem.description1 &&
                this.selectedItem.description1.length
            ) {
                data = [...data, ...this.selectedItem.description1]
                //console.log('Description1', data)
            }
            if (
                this.selectedItem &&
                this.selectedItem.description2 &&
                this.selectedItem.description2.length
            ) {
                data = [...data, ...this.selectedItem.description2]
                //console.log('Description2', data)
            }
            if (
                this.selectedItem &&
                this.selectedItem.description3 &&
                this.selectedItem.description3.length
            ) {
                data = [...data, ...this.selectedItem.description3]
                //console.log('Description3', JSON.stringify(data))
            }

            //console.log('Description', data)

            return data
        }, // End of description() method
        occupation() {
            let data = []
            if (
                this.selectedItem &&
                this.selectedItem.occupationCategory &&
                this.selectedItem.occupationCategory.length
            ) {
                data = [...data, ...this.selectedItem.occupationCategory]
            }

            return data
        }, // End of occupation() method
        sanctions() {
            let data = []
            if (
                this.selectedItem &&
                this.selectedItem.sanctionList &&
                this.selectedItem.sanctionList.length
            ) {
                data = [...data, ...this.selectedItem.sanctionList]
            }

            return data
        }, // End of sanctions() method
        image() {
            if (this.selectedItem && this.selectedItem.source) {
                if (this.selectedItem.source == 'blackList') {
                    return `${process.env.VUE_APP_API_URL}files/logo/${this.displaySettings.logo.dark.fileName}`
                } else {
                    return require('@/assets/images/dummy/' +
                        this.selectedItem.source +
                        '.png')
                }
            }
            return ''
        },
        locations() {
            if (
                this.selectedItem &&
                this.selectedItem.country &&
                this.selectedItem.country.length
            ) {
                let locations = this.selectedItem.country.filter((v) => {
                    return v.type === 'Location'
                })
                if (locations && locations.length) {
                    return locations
                }
            }

            return []
        }, // End of caregories() method
    }, // End of Component > computed
    methods: {
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */

        hideModal() {
            this.$refs['my-modal'].hide()
        },

        print() {
            window.print()
        },
        updatedOnDate: function (date) {
            //console.log('updatedOnDate -> ', date)
            if (date) {
                return this.$moment(date).format('MMM DD, YYYY')
            }
            return 'N/A'
        },
        dateOfBirth: function (selectedItem) {
            //console.log(selectedItem)
            if (
                selectedItem.dates &&
                selectedItem.dates.length &&
                selectedItem.dates[0].year !== 'Invalid date'
            ) {
                selectedItem.dates = selectedItem.dates.filter((v) => {
                    return v.type === 'Date of Birth'
                })
                return this.$moment(
                    `${selectedItem.dates[0].year}-${selectedItem.dates[0].month}-${selectedItem.dates[0].day} `,
                    'YYYY-MM-DD'
                ).format('MMM DD, YYYY')
            } else if (selectedItem.addedOn) {
                return this.$moment(selectedItem.addedOn).format('MMM DD, YYYY')
            }
            return 'N/A'
        },
    },
}
</script>
